/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Po_Pending_Changes_OwnInputs */

const en_po_pending_changes_own = /** @type {(inputs: Po_Pending_Changes_OwnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proposals waiting for Tomorrow: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Proposals waiting for Tomorrow: {count}" |
*
* @param {Po_Pending_Changes_OwnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_pending_changes_own = /** @type {((inputs: Po_Pending_Changes_OwnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Pending_Changes_OwnInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_pending_changes_own(inputs)
});